import React from "react";
import {
  Drawer,
  Accordion,
  AccordionSummary,
  Typography,
  Box,
} from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import {
  FaUserPlus,
  FaWallet,
  FaMoneyBill,
  FaFileInvoiceDollar,
  FaExchangeAlt,
  FaQuestionCircle,
  FaKey,
  FaLock,
  FaEnvelope,
  FaMobile,
  FaBus,
  FaCreditCard,
  FaUserShield,
  FaBell,
  FaBug,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const drawerWidth = 250;

const sections = [
  { text: "Registration", icon: <FaUserPlus />, path: "/helpcenterlayout/registration" },
  { text: "Upgrade Wallet", icon: <FaWallet />, path: "/helpcenterlayout/upgradewallet" },
  { text: "Load Money", icon: <FaMoneyBill />, path: "/helpcenterlayout/loadmoney" },
  {
    text: "Bill Payments",
    icon: <FaFileInvoiceDollar />,
    path: "/helpcenterlayout/billpayments",
  },
  {
    text: "Send or Receive Money",
    icon: <FaExchangeAlt />,
    path: "/helpcenterlayout/sendreceivemoney",
  },
  { text: "Merchant Pay", icon: <FaWallet />, path: "/helpcenterlayout/merchantpay" },
  { text: "IMPS", icon: <FaExchangeAlt />, path: "/helpcenterlayout/imps" },
  {
    text: "Transaction Information",
    icon: <FaQuestionCircle />,
    path: "/helpcenterlayout/transactionstatus",
  },
  { text: "Favourites", icon: <FaQuestionCircle />, path: "/helpcenterlayout/favourites" },
  { text: "TPIN Functionality", icon: <FaKey />, path: "/helpcenterlayout/tpin" },
  { text: "Password", icon: <FaLock />, path: "/helpcenterlayout/passwordhelp" },
  { text: "Email", icon: <FaEnvelope />, path: "/helpcenterlayout/emailhelp" },
  { text: "Mobile Recharge", icon: <FaMobile />, path: "/helpcenterlayout/rechargehelp" },
  { text: "Bus Tickets", icon: <FaBus />, path: "/helpcenterlayout/bustickethelp" },
  {
    text: "Rupay Prepaid Card",
    icon: <FaCreditCard />,
    path: "/helpcenterlayout/virtualcardhelp",
  },
  {
    text: "Privacy and Settings",
    icon: <FaUserShield />,
    path: "/helpcenterlayout/securityhelp",
  },
  { text: "Notifications", icon: <FaBell />, path: "/helpcenterlayout/notificationhelp" },
  { text: "Report an issue", icon: <FaBug />, path: "/helpcenterlayout/feedbacksupport" },
];

const Sidebar = ({ isMobile, mobileOpen, handleDrawerToggle }) => {
  const navigate = useNavigate();

  const sidebarContent = (
    <Box sx={{ width: drawerWidth, p: 2, backgroundColor: "#f9f9f9" }}>
      {sections.map((sec, i) => (
        <Accordion key={i} disableGutters elevation={0}>
          <AccordionSummary
            expandIcon={<ArrowRightIcon />}
            onClick={() => {
              navigate(sec.path);
              if (isMobile) handleDrawerToggle();
            }}
            sx={{
              cursor: "pointer",
              "&:hover": { backgroundColor: "#f0f0f0" },
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <Box sx={{ color: "#555", fontSize: 18 }}>{sec.icon}</Box>
              <Typography fontSize={14}>{sec.text}</Typography>
            </Box>
          </AccordionSummary>
        </Accordion>
      ))}
    </Box>
  );

  return (
    <Drawer
      variant={isMobile ? "temporary" : "permanent"}
      open={isMobile ? mobileOpen : true}
      onClose={handleDrawerToggle}
      ModalProps={{ keepMounted: true }}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          top: isMobile ? 0 : "64px", // ⬅️ Push below Appbar on desktop
          height: isMobile ? "100%" : "calc(100% - 64px)", // ⬅️ Adjust height
        },
      }}
    >
      {sidebarContent}
    </Drawer>
  );
};

export default Sidebar;
